import { render, staticRenderFns } from "./CurrencyAlloc.vue?vue&type=template&id=a38cb694&scoped=true&"
import script from "./CurrencyAlloc.vue?vue&type=script&lang=js&"
export * from "./CurrencyAlloc.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyAlloc.vue?vue&type=style&index=0&id=a38cb694&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38cb694",
  null
  
)

export default component.exports